import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const getVacationStatusByEmployee = (id) =>
  requestsTemplates.get(mainPath, `/vacations/${id}/type`);
  